(() => {
  const initializeHero = root => {
    if (root.dataset.pdpReady === 'true') return;
    root.dataset.pdpReady = 'true';

    const form = root.querySelector('form');
    if (form) {
      const plans = [...root.querySelectorAll('[data-pdp-plan]')];
      const variant = form.querySelector('[data-pdp-variant]');
      const quantity = form.querySelector('[data-pdp-quantity]');
      const total = form.querySelector('[data-pdp-total]');
      const submit = form.querySelector('[data-pdp-submit]');
      const submitLabel = form.querySelector('[data-pdp-submit-label]');
      const buyNow = form.querySelector('[data-pdp-buy-now]');
      const stickyAdd = root.querySelector('[data-pdp-sticky-add]');
      const stickyTotal = stickyAdd?.querySelector('[data-pdp-sticky-total]');
      const choose = plan => {
        if (!plan || plan.classList.contains('is-disabled')) return;
        plans.forEach(item => item.classList.toggle('is-selected', item === plan));
        const radio = plan.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        if (variant) variant.value = plan.dataset.variant;
        if (quantity) quantity.value = plan.dataset.quantity;
        if (total) total.textContent = plan.dataset.total;
        if (stickyTotal) stickyTotal.textContent = plan.dataset.total;
        if (submit) submit.disabled = false;
        if (buyNow) buyNow.disabled = false;
        if (stickyAdd) stickyAdd.disabled = false;
        if (submitLabel && submit) submitLabel.textContent = submit.dataset.availableLabel;
      };
      plans.forEach(plan => {
        plan.addEventListener('change', () => choose(plan));
        plan.addEventListener('click', () => choose(plan));
      });
      const initialPlan = plans.find(plan => plan.classList.contains('is-selected') && !plan.classList.contains('is-disabled')) || plans.find(plan => !plan.classList.contains('is-disabled'));
      if (initialPlan) choose(initialPlan);

      const selection = () => ({
        variantId: variant?.value,
        quantity: Math.max(1, Number.parseInt(quantity?.value || '1', 10) || 1),
        product: {
          title: root.dataset.cartProductTitle,
          url: root.dataset.cartProductUrl,
          image: root.dataset.cartProductImage,
          total: total?.textContent,
          unitCents: plans.find(plan => plan.classList.contains('is-selected'))?.dataset.unitCents
        }
      });
      form.addEventListener('submit', event => {
        if (!window.FloreCart?.add || !variant?.value) return;
        event.preventDefault();
        const selected = selection();
        window.FloreCart.add(selected.variantId, selected.quantity, selected.product);
      });
      buyNow?.addEventListener('click', () => {
        if (!window.FloreCart?.buyNow || !variant?.value) return;
        const selected = selection();
        window.FloreCart.buyNow(selected.variantId, selected.quantity);
      });
      stickyAdd?.addEventListener('click', () => {
        if (!submit || submit.disabled || !variant?.value) return;
        if (form.requestSubmit) form.requestSubmit(submit);
        else submit.click();
      });
    }

    const gallery = root.querySelector('[data-pdp-gallery]');
    const viewport = gallery?.querySelector('[data-pdp-gallery-viewport]');
    if (viewport) {
      const slides = [...gallery.querySelectorAll('[data-pdp-gallery-slide]')];
      const thumbnails = [...gallery.querySelectorAll('[data-pdp-gallery-thumbnail]')];
      const previous = gallery.querySelector('[data-pdp-gallery-prev]');
      const next = gallery.querySelector('[data-pdp-gallery-next]');
      const current = gallery.querySelector('[data-pdp-gallery-current]');
      let active = 0;
      const update = index => {
        active = Math.max(0, Math.min(slides.length - 1, index));
        thumbnails.forEach((thumb, i) => {
          thumb.classList.toggle('is-active', i === active);
          thumb.setAttribute('aria-current', i === active ? 'true' : 'false');
        });
        if (previous) previous.disabled = active === 0;
        if (next) next.disabled = active === slides.length - 1;
        if (current) current.textContent = active + 1;
      };
      const goTo = index => {
        update(index);
        viewport.scrollLeft = active * viewport.clientWidth;
      };
      thumbnails.forEach((thumb, i) => thumb.addEventListener('click', () => goTo(i)));
      previous?.addEventListener('click', () => goTo(active - 1));
      next?.addEventListener('click', () => goTo(active + 1));
      viewport.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(active + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      let scrollFrame;
      viewport.addEventListener('scroll', () => {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(() => update(Math.round(viewport.scrollLeft / viewport.clientWidth)));
      }, { passive: true });
      update(0);
    }

    const sticky = root.querySelector('[data-pdp-sticky]');
    const hero = root.querySelector('.fpdp-hero');
    if (sticky && hero) {
      new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
        sticky.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        sticky.inert = entry.isIntersecting;
      }, { threshold: .05 }).observe(hero);
    }
  };

  const initializeAll = () => document.querySelectorAll('[data-pdp-hero]').forEach(initializeHero);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', initializeAll);
})();
